export default "__VITE_ASSET__Bu0N0y8v__"